import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import './Header.css';

const Header = ({ title, subtitle, icon, showActions = true, studentClass, hidePill = false, externalUnreadCount }) => {
    const { t } = useTranslation(['navigation', 'common']);
    const navigate = useNavigate();

    const [unreadCount, setUnreadCount] = useState(0);
    const userId = localStorage.getItem('userId') || 1;

    // Use external unread count if provided, otherwise use internal state
    const displayUnreadCount = externalUnreadCount !== undefined ? externalUnreadCount : unreadCount;

    // Fetch from localStorage
    const savedName = localStorage.getItem('studentName') || 'Student';
    const savedClass = studentClass || localStorage.getItem('studentClass') || '10';

    const fetchUnreadCount = useCallback(async () => {
        // Skip fetch if unread count is provided externally
        if (!userId || externalUnreadCount !== undefined) return;
        try {
            const response = await fetch(`${API_BASE_URL}get_notifications.php?user_id=${userId}`);
            const data = await response.json();
            if (data.status === 'success') {
                setUnreadCount(data.unread_count);
            }
        } catch (error) {
            console.error('Error fetching unread count:', error);
        }
    }, [userId, externalUnreadCount]);

    useEffect(() => {
        fetchUnreadCount();
        if (externalUnreadCount === undefined) {
            const interval = setInterval(fetchUnreadCount, 60000);
            return () => clearInterval(interval);
        }
    }, [fetchUnreadCount, externalUnreadCount]);

    const handleToggleSidebar = () => {
        window.dispatchEvent(new CustomEvent('toggleSidebar'));
    };

    return (
        <header className="dashboard-header-strip">
            {/* Hamburger toggle — placed before all header content */}
            <button
                className="header-sidebar-toggle"
                onClick={handleToggleSidebar}
                aria-label="Toggle sidebar"
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '42px',
                    height: '42px',
                    fontSize: '1.35rem',
                    color: '#1e1b4b',
                    background: 'rgba(99,102,241,0.08)',
                    border: '1px solid rgba(99,102,241,0.2)',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    flexShrink: 0,
                    padding: 0,
                    marginRight: '0.5rem',
                }}
            >
                ☰
            </button>

            <div className="header-strip-left">
                {icon && <div className="header-title-icon">{icon}</div>}
                <div className="header-text-block">
                    <h1>{title || `👤 ${t('navigation:header.welcome', 'Welcome back')}, ${savedName} (${t('navigation:header.class', 'Class')} ${savedClass})`}</h1>
                    {subtitle && <p className="header-subtitle">{subtitle}</p>}
                </div>
            </div>


            {showActions && (
                <div className="header-strip-actions">
                    {!hidePill && (
                        <div className="class-badge-pill">
                            <span>{t('navigation:header.class', 'Class')} {savedClass}</span>
                            <i className="dropdown-chevron">⌄</i>
                        </div>
                    )}

                    <div
                        className="notification-bell-frosted"
                        onClick={() => navigate('/notifications')}
                        style={{ cursor: 'pointer' }}
                        title={t('navigation:header.notificationsTitle', 'View Notifications')}
                    >

                        <span className="bell-icon">🔔</span>
                        {displayUnreadCount > 0 && <span className="status-dot"></span>}
                    </div>
                    <div
                        className="user-avatar-premium"
                        onClick={() => navigate('/profile')}
                        style={{ cursor: 'pointer' }}
                        title={t('navigation:header.profileTitle', 'View Profile')}
                    >

                        <div className="avatar-initials">{(localStorage.getItem('studentName') || 'S')[0]}</div>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;


